<template>
  <el-dialog
    title="發佈至FB"
    :visible.sync="mIsShow"
    append-to-body
    width="592px"
    height="500px"
    v-loading="isLoading">
    <span>
      <el-input type="textarea" rows="20" v-model="content"/>

      <div v-show="submitType === 'media' && imageURLs && imageURLs.length" class="media-preview-container">
        <img v-for="(url, idx) in imageURLs" :key="`post-img-${idx}`" :src="url"/>
      </div>
    </span>
    <div slot="footer" class="dialog-footer">
      <el-tooltip class="item" effect="dark" content="發佈貼文時會夾帶所有圖片" placement="top">
        <el-radio v-model="submitType" :disabled="mediaList.length==0" label="media">以多媒體形式發佈</el-radio>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="發佈時不會夾帶圖片，但是會大大顯示網站文章連結的預覽，通常預覽會包含封面圖片" placement="top">
        <div slot="content">發佈時不會夾帶圖片，<br>但是會大大顯示網站文章連結的預覽，<br>通常預覽會包含封面圖片</div>
        <el-radio v-model="submitType" label="link">以連結形式發佈</el-radio>
      </el-tooltip>

      <el-button @click="close">取消</el-button>
      <el-tooltip v-if="$store.getters.adminMissValidIGAccessToken" effect="dark" content="請先刷新FB登入" placement="bottom">
        <span>
          <el-button type="primary" @click="submit" :disabled="$store.getters.adminMissValidFBPageAccessToken">發佈</el-button>
        </span>
      </el-tooltip>
      <el-button v-else type="primary" @click="submit" :disabled="$store.getters.adminMissValidFBPageAccessToken">發佈</el-button>
      <el-button v-show="$store.getters.adminMissValidFBPageAccessToken" @click="authFB">刷新驗證</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinAuthFB from '@/utils/fb/mixin-auth.vue'

export default {
  mixins: [MixinAuthFB],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    article: {
    }
  },
  data () {
    return {
      mIsShow: false,
      content: '',
      submitType: 'media', // media or link
      mediaList: [],
      isLoading: false
    }
  },
  computed: {
    imageURLs () {
      return this.mediaList.filter(o => o.type === 'image').map(o => o.url)
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    preview () {
      var i
      let contentJsonArr = JSON.parse(this.article.Tw.Contents)

      // 1. 處理文字
      const domParser = new DOMParser()
      const htmlStr2TextStr = (html) => {
        let doc = domParser.parseFromString(html, 'text/html')
        return doc.body.innerText
      }
      const notAllowedConvertedToStrTypes = ['image', 'carousel', 'video', 'videofromurl'] // image, video use media url format post to fb.
      const block2Str = (block) => {
        if (block.type === 'title') return htmlStr2TextStr(block.value)
        if (block.type === 'subtitle') return htmlStr2TextStr(block.value)
        if (block.type === 'content') return htmlStr2TextStr(block.value)
        if (block.type === 'quote') return htmlStr2TextStr(block.value)
        if (block.type === 'comment') return htmlStr2TextStr(block.value)
        if (block.type === 'code') return htmlStr2TextStr(block.value)
        if (block.type === 'htmlcode') return htmlStr2TextStr(block.value)
        if (block.type === 'link') return block.url
        // if (block.type === 'video') return block.value
        // if (block.type === 'videofromurl') return block.value

        if (block.type === 'complex') {
          let s1 = block2Str(block.value.value1)
          let s2 = block2Str(block.value.value2)
          if (s1 === null && s2 === null) return null
          if (s1 === null) return s2
          if (s2 === null) return s1
          return s1 + '\r\n\r\n' + s2
        }
        if (notAllowedConvertedToStrTypes.includes(block.type)) return null
        return `error: unknown type ${block.type}`
      }
      var content = ''
      for (i = 0; i < contentJsonArr.length; ++i) {
        let block = contentJsonArr[i]
        if (content !== '') content += '\r\n\r\n'
        let blockStr = block2Str(block)
        if (blockStr && blockStr !== null) content += blockStr
      }
      this.content = content

      // 2. 處理多媒體
      const getBlockMedia = (block) => {
        var arr = []
        if (block.type === 'image') {
          arr.push({ type: 'image', url: block.value.img })
        } else if (block.type === 'video') {
          arr.push({ type: 'video', url: block.value })
        } else if (block.type === 'videofromurl') {
          arr.push({ type: 'videofromurl', url: block.value })
        } else if (block.type === 'complex') {
          arr = arr.concat(getBlockMedia(block.value.value1))
          arr = arr.concat(getBlockMedia(block.value.value2))
        } else if (block.type === 'carousel') {
          for (var subBlock of block.value.items) {
            arr = arr.concat(getBlockMedia(subBlock))
          }
        }
        return arr
      }
      var mediaList = []
      if (this.article.Tw.CoverImageURLX3) {
        mediaList.push({ type: 'image', url: this.article.Tw.CoverImageURLX3 })
      }
      for (i = 0; i < contentJsonArr.length; ++i) {
        let block = contentJsonArr[i]
        mediaList = mediaList.concat(getBlockMedia(block))
      }
      this.mediaList = mediaList
      if (mediaList.length === 0) {
        this.submitType = 'link'
      }
    },
    submit () {
      if (this.$store.getters.adminMissValidFBAccessToken) {
        if (!window.confirm('請先登入FB!')) return
        return this.authFB().then(this.submit).catch(console.error)
      }

      let payload = {
        articleID: this.article.ID,
        submitType: this.submitType,
        content: this.content,
        imageUrls: this.imageURLs
      }
      this.$services.post.post2FB(this, payload).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let newArticle = res.data.result
          let idx = this.$store.state.post.list.findIndex(o => o.ID === newArticle.ID)
          if (idx >= 0) {
            this.$set(this.$store.state.post.list, idx, newArticle)
          }
          this.$notify({ message: '發佈成功!' })
          this.$emit('deploy-successful')
          this.close()
        }
      }).catch(this.$handleServiceError)
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        this.preview()
      }
    }
  }
}
</script>

<style scoped>
.media-preview-container {
  width: 100%;
  height: 50px;
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: 4px;
}
.media-preview-container img {
  width: 50px;
  height: 50px;
  object-fit: cover;
}
.media-preview-container img:not(:first-child) {
  margin-left: 2px;
}

</style>
